import React from 'react';

import PropTypes from 'prop-types';
import { Table, Label, Button } from 'semantic-ui-react';

import _startCase from 'lodash/startCase';

import { ThemeTemplatePropTypes } from 'components/modules/theme-templates/types';

import './ThemeTemplatesTableRow.scss';

const propTypes = {
  template: ThemeTemplatePropTypes.isRequired,
  onViewTemplate: PropTypes.func.isRequired,
  onEditTemplate: PropTypes.func.isRequired,
  onApplyTemplate: PropTypes.func.isRequired,
};

const defaultProps = {};

function ThemeTemplatesTableRow({ template, onViewTemplate, onEditTemplate, onApplyTemplate }) {
  const { name, description, tags, type } = template;

  return (
    <Table.Row className="theme-templates-table-row">
      <Table.Cell width={4} onClick={() => onViewTemplate(template)} className="name-column">
        {name}
      </Table.Cell>
      <Table.Cell width={6} className="description-column">
        {description || '-'}
      </Table.Cell>
      <Table.Cell width={2}>
        <Label basic>{_startCase(type)}</Label>
      </Table.Cell>
      <Table.Cell width={4}>
        {tags.map((tag) => (
          <Label key={tag} basic>
            {_startCase(tag)}
          </Label>
        ))}
      </Table.Cell>
      <Table.Cell textAlign="right" collapsing>
        <Button
          content="Edit"
          icon="pencil"
          size="small"
          color="black"
          basic
          className="edit-template-button"
          onClick={() => onEditTemplate(template)}
        />
        <Button
          content="Apply"
          icon="check"
          size="small"
          color="black"
          className="apply-template-button"
          onClick={() => onApplyTemplate(template)}
        />
      </Table.Cell>
    </Table.Row>
  );
}

ThemeTemplatesTableRow.propTypes = propTypes;
ThemeTemplatesTableRow.defaultProps = defaultProps;

export default ThemeTemplatesTableRow;
